import { useDispatch, useSelector } from "react-redux";
import actions from "../store/actions";
import { getUrlParamsBySearch } from "../utils/index";
import { appReducersActions } from "../store/reducers/app";
import { isEmpty } from "../utils";
import { useState, useEffect, useMemo } from "react";
import Fingerprint2 from "@fingerprintjs/fingerprintjs";
import { useIntl } from "react-intl";
import {
  getAnswer,
  removeAnswer,
  setAnswer,
  getFinger,
  setFinger,
} from "../utils/storage";
/**
 * 打乱数组数据
 * @param {array} list 源数据
 * @param {boolean} checkFixed 检查固定
 * @returns array
 */
function listRandom(list, checkFixed) {
  let m = list.length,
    i,
    t;
  while (m) {
    i = Math.floor(Math.random() * m--);
    if (checkFixed === true) {
      if (!list[m].fixed && !list[i].fixed) {
        t = list[m];
        list[m] = list[i];
        list[i] = t;
        // // 重置position
        // list[m].position = m;
        // list[i].position = i;
      }
    } else {
      t = list[m];
      list[m] = list[i];
      list[i] = t;
      //   // 重置position
      //   list[m].position = m;
      //   list[i].position = i;
    }
  }
  return list;
}
/** 处理接口数据 */
export const useFormateData = (form) => {
  const dispatch = useDispatch();
  const { isQuestion } = useUtils();
  const handler = (data) => {
    let quesNum = 1;
    let pageNum = 1;
    // 打乱题目
    if (data.quesRandom) {
      data.questionList = listRandom(data.questionList);
    }
    data.questionList?.forEach((item, index) => {
      item.position = index;
      item.type = item.type.toString();
      if (isQuestion(item.type)) {
        item.quesNum = quesNum;
        quesNum++;
      }
      // 处理分页
      if (item.type === "4") {
        pageNum++;
        item.pageNum = pageNum;
      } else {
        item.pageNum = pageNum;
      }
      // 关联问题隐藏
      if (item.questionRelateList && item.questionRelateList.length !== 0) {
        item.relateShow = false;
      } else {
        item.relateShow = true;
      }
      //打乱选项
      if (item.ansRandom && item.answerList) {
        item.answerList = listRandom(item.answerList, true);
      }
      if (item.matrixRandom && item.matrixRowList) {
        item.matrixRowList = listRandom(item.matrixRowList);
      }

      //如果 matrixRowList 或 answerList 没有position 则加上
      if (item.matrixRowList)
        item.matrixRowList = item.matrixRowList.map((o, i) => ({
          ...o,
          position: isEmpty(o.position) ? i : o.position,
        }));
      if (item.answerList)
        item.answerList = item.answerList.map((o, i) => ({
          ...o,
          position: isEmpty(o.position) ? i : o.position,
        }));
    });
    // 保存总页数
    dispatch(appReducersActions.setTotalPage(pageNum));
  };

  return { handler };
};
/**
 * 处理关联关系
 */
export const useRelateHandler = (form) => {
  const handler = ({ quesList, postAnswer = [] }) => {
    quesList.forEach((item) => {
      let show = true;
      if (item.questionRelateList) {
        //查找是否有一题的选项是关联此题且已选中
        show =
          item.questionRelateList.find((o) => {
            //获取关联问题的positions
            let relateQues = quesList[o.relatePosition];
            //关联题目是隐藏的则直接隐藏
            const ishide =
              relateQues.jumpShow === false || relateQues.relateShow === false;
            if (ishide === true) return false;
            let relateAnswerList = relateQues.answerList;
            let relateQuesAnswer = postAnswer[o.relatePosition];
            if (!relateQuesAnswer) return false;
            let answerPosition = o.relateAnswerPositions
              .split(",")
              .map((o) => relateAnswerList[o].position.toString());
            // 矩阵关联
            if (o.relateMatrixPosition !== undefined) {
              const matchRowAnswer = relateQuesAnswer.find(
                (i) =>
                  i.rowPosition.toString() === o.relateMatrixPosition.toString()
              );
              if (!matchRowAnswer) return false;
              return (
                answerPosition.indexOf(matchRowAnswer.colPosition.toString()) >=
                0
              );
            } else {
              let s = relateQuesAnswer.find(
                (i) =>
                  answerPosition.indexOf(i.position.toString()) >= 0 &&
                  i.checked
              );
              return s;
            }
          }) || false;
      }
      item.relateShow = !!show;
    });
  };
  return { handler };
};
// 处理跳转逻辑
export const useJumpHandler = (form) => {
  const dispatch = useDispatch();
  const { checkEmpty, isSame } = useUtils();
  const handler = ({ quesItem, postAnswer, answerData, quesList }) => {
    //跳题逻辑逻辑
    let firstItem = quesItem.jumpList?.[0];
    // 跳转类型
    let jumpType;
    if (firstItem) {
      // 需处理跳题关系问题的起始位置
      let fromPosition = quesItem.position + 1;
      //跳题位置
      let toPosition = quesList.length;
      // 选项跳转,符合题型: 单选和NPS量表
      if (!isEmpty(firstItem.answerPosition)) {
        let checkItem = answerData?.find((o) => o.checked);
        // 查找该选项是否有跳题关系
        let matchItem = quesItem.jumpList.find((o) =>
          isSame(o.answerPosition, checkItem?.source.position)
        );
        toPosition = matchItem?.jumpQuesPosition || quesItem.position;
      }
      // 无条件跳转
      else {
        toPosition = firstItem.jumpQuesPosition;
      }
      // 根据已选答案，决定跳转位置
      if (["-2", "-3"].indexOf(toPosition?.toString()) >= 0) {
        jumpType = toPosition.toString();
        toPosition = quesList.length;
      } else {
        jumpType = "0";
      }
      dispatch(appReducersActions.setJumpType(jumpType));
      for (let i = fromPosition; i < toPosition; i++) {
        // 没有答案的时候，jumpshow = true
        let show = checkEmpty(postAnswer[quesItem.position], quesItem.type);
        quesList[i].jumpShow = show;
        // 当该题型因跳题隐藏时，清掉答案,清掉错误信息
        if (show == false) {
          postAnswer[i] = undefined;
          quesList[i].errorMsg = undefined;
        }
      }
      for (let i = toPosition; i < quesList.length; i++) {
        quesList[i].jumpShow = true;
      }
    }
    return { quesList, postAnswer, jumpType };
  };
  return { handler };
};
// 对已选答案进行缓存
const useSaveToStorage = (form) => {
  const { currentPage, firstTime } = useSelector((state) => state.app);
  const handler = (postAnswer) => {
    const { suveryInfo } = form.getFieldsValue();
    const { questionList } = suveryInfo;
    let answerData = [];
    postAnswer.forEach((answerItem, i) => {
      if (answerItem) {
        const quesItem = questionList[i];
        let tempData;
        switch (quesItem.type.toString()) {
          // 单选、多选、nps、排序
          // eg: 1=>abc,2=>dce
          // 1,2 position标识; => 切割符; abc,dce 选项填空文字
          case "1":
          case "2":
          case "8":
          case "9":
            tempData = answerItem
              .filter((o) => o.checked)
              .map((o, i) => {
                return `${o.position}${
                  o.answerText ? "=>" + o.answerText : ""
                }`;
              })
              .join(",");
            break;
          // 矩阵单选，矩阵量表
          // eg: 1_2,3_4
          // _ 分割符; 1,3 行位置; 2，4 列位置
          case "6":
          case "7":
            tempData = answerItem
              .map((o) => `${o.rowPosition}_${o.colPosition}`)
              .join(",");
            break;
          case "3":
            tempData = answerItem;
            break;
          case "10":
            let _list = answerItem.filter((o) => o.status == "success");
            if (_list.length != 0) {
              tempData = _list.map((o) => o.url).join(",");
            }
            break;
          default:
            break;
        }
        if (tempData) {
          // [问题位置,问题类型,已填答案]
          answerData.push([i.toString(), quesItem.type, tempData]);
        }
      }
    });
    let storeData = getAnswer(suveryInfo.id);
    if (!storeData) storeData = {};
    storeData.answerData = answerData;
    storeData.currentPage = currentPage;
    storeData.lastFirstTime = storeData.lastFirstTime || firstTime;
    storeData.id = suveryInfo.id;
    storeData.answerTime = new Date().getTime();
    setAnswer(suveryInfo.id, storeData);
  };
  return { handler };
};

export const useChange = (form) => {
  const { handler: relateHandler } = useRelateHandler(form);
  const { handler: jumpHandler } = useJumpHandler(form);
  const { handler: storageHandler } = useSaveToStorage(form);
  const handler = (val, allVal) => {
    let key = Object.keys(val)[0];
    if (key != "postAnswer") return;
    let { suveryInfo, postAnswer } = form.getFieldsValue();
    let { questionList: quesList } = suveryInfo;
    // 找出是那个问题提交答案或清除答案
    const clearIndex = val[key].findIndex((o) => o === "$=>clear");
    let index = undefined;
    // 清空答案将值置空
    if (clearIndex >= 0) {
      index = clearIndex;
      postAnswer[clearIndex] = undefined;
      // 填空题置undefined时，文本框未正确清空，需置字符串空""
      if (quesList[index].type === "3") {
        postAnswer[clearIndex] = "";
      }
      val[key][clearIndex] = undefined;
    } else {
      index = val[key].findIndex((o) => o !== undefined);
    }
    let answerData = val[key][index];
    // 该问题的答案
    let quesItem = quesList[index];
    quesList[index].errorMsg = undefined;
    // 处理跳转逻辑
    jumpHandler({ quesList, quesItem, postAnswer, answerData });
    // 处理关联逻辑
    relateHandler({ quesList, postAnswer });
    form.setFieldsValue({
      suveryInfo: { ...suveryInfo, questionList: quesList },
      postAnswer,
    });
    storageHandler(postAnswer);
  };

  return { handler };
};

/**检查当页问题是否必填，已选选项是否超出限制等 */
export const useCheckCurrentPageValidate = (form) => {
  const { formatMsg } = useFormateMsg();
  const { checkEmpty, isQuestion, isSame } = useUtils();
  const { currentPage } = useSelector((state) => state.app);
  const handler = (quesItem) => {
    let status = true;
    const { suveryInfo, postAnswer } = form.getFieldsValue();
    let questionList = suveryInfo.questionList;
    postAnswer?.forEach((item, index) => {
      let quesItem = questionList[index];
      const {
        type,
        pageNum,
        relateShow,
        jumpShow,
        required,
        minChoice,
        maxChoice,
        matrixRowList,
      } = quesItem;
      // 只检查当页问题,且当前问题没有隐藏
      if (
        isQuestion(type) &&
        currentPage == pageNum &&
        relateShow !== false &&
        jumpShow !== false
      ) {
        let errorMsg;
        // 检查必填
        if (required) {
          if (
            (type == "6" || type == "7") &&
            item?.length != matrixRowList.length
          ) {
            let positions = matrixRowList
              .map((o) => {
                let has = item?.find((i) => isSame(i?.rowPosition, o.position));
                return has ? undefined : o.position;
              })
              .filter((o) => !isEmpty(o));
            errorMsg = { positions, msg: formatMsg("errormsg.pleaseAnswer") };
          } else if (checkEmpty(item, type)) {
            errorMsg = formatMsg("errormsg.pleaseAnswer");
          }
        }
        // 检查选项的必答
        if (!errorMsg && ["1", "2", "9"].indexOf(type.toString()) >= 0) {
          let noValItem = item?.find(
            (o) => o.checked && o.source.type.toString() === "1" && o.source.required && !o.answerText
          );
          if (noValItem) errorMsg = formatMsg("errormsg.textRequire");
        }
        // 检查多选和排序的选项个数
        if (!errorMsg && ["2", "9"].indexOf(type.toString()) >= 0) {
          let checkArr = item?.filter((o) => o.checked) || [];
          //检查少选
          if (checkArr.length < minChoice)
            errorMsg = formatMsg("questionTitle.choiceTxt-less").replace(
              "$1",
              minChoice
            );
          //检查多选
          else if (checkArr.length > maxChoice)
            errorMsg = formatMsg("questionTitle.choiceTxt-more").replace(
              "$1",
              maxChoice
            );
        }
        // 检查图片上传是否已完成上传且成功
        if (!errorMsg && type == "10") {
          let tempItem = item?.find(
            (o) => o.status == "uploading" || o.status == "failed"
          );
          if (tempItem && tempItem.status == "uploading")
            errorMsg = formatMsg("errormsg.upload.ing");
          if (tempItem && tempItem.status == "failed")
            errorMsg = formatMsg("errormsg.upload.failed");
        }
        if (errorMsg) {
          status = false;
          questionList.splice(index, 1, { ...quesItem, errorMsg });
        }
      }
    });
    return { status, questionList };
  };
  return { handler };
};

export const useSubmit = (form) => {
  const dispatch = useDispatch();
  const { jumpType } = useSelector((state) => state.app);
  const handler = () => {
    const { postAnswer, suveryInfo } = form.getFieldsValue();
    let answerData = postAnswer.map((answerItem, i) => {
      if (!answerItem) return undefined;
      let quesItem = suveryInfo.questionList[i];
      let answerList;
      switch (quesItem.type.toString()) {
        case "1":
        case "2":
        case "8":
        case "9":
          answerList = answerItem
            .filter((o) => o.checked)
            .map((o, i) => ({
              answerText: o.answerText,
              answerId: o.answerId,
              // 只有排序题才记录order
              order: quesItem.type == "9" ? i + 1 : "",
            }));
          break;
        case "3":
          if (!!answerItem.trim()) {
            answerList = [{ answerText: answerItem }];
          }
          break;
        case "6":
        case "7":
          answerList = answerItem;
          break;
        case "10":
          answerList = [{ answerText: answerItem.map((o) => o.url).join(",") }];
          break;
        default:
          break;
      }
      // 如果该题是不显示的，则过滤
      if (quesItem.relateShow === false || quesItem.jumpShow === false) {
        return undefined;
      }
      return {
        questionId: quesItem.id,
        questionType: quesItem.type,
        answerList,
      };
    });
    let data = { checkList: answerData.filter((o) => o) };
    let storeData = getAnswer(suveryInfo.id);
    let uuid = getFinger();
    // 记录的是毫秒，接口需要的是秒
    let duration =
      (storeData.costTime || 0) +
      (new Date().getTime() - storeData.lastFirstTime);
    duration = duration / 1000;
    dispatch(appReducersActions.setPosting(true));
    actions
      .postData({ ...data, duration, uuid, status: jumpType != "-3" ? 1 : 0 })
      .then(() => {
        dispatch(appReducersActions.setTipsPage({ status: "success" }));
        removeAnswer(suveryInfo.id);
      })
      .catch((e) => {
        if (e instanceof Error) {
          dispatch(appReducersActions.setTipsPage({ status: "network" }));
        } else {
          dispatch(appReducersActions.setTipsPage({ status: e.code }));
        }
      })
      .finally(() => dispatch(appReducersActions.setPosting(false)));
  };
  return {
    handler,
  };
};

export const useShowStorage = () => {
  const dispatch = useDispatch();
  const handler = (suveryInfo) => {
    let storeData = getAnswer(suveryInfo.id);
    if (storeData) {
      dispatch(appReducersActions.setStorageModal(true));
    }
  };
  return { handler };
};

export const useInit = (form) => {
  const dispatch = useDispatch();
  const { handler: formateData } = useFormateData(form);
  const { handler: showStorage } = useShowStorage();
  const [loading, _setLoading] = useState(true);
  let params = getUrlParamsBySearch();
  const setLoading = (show) => {
    let el = document.querySelector("#loadingEl");
    if (show == false) {
      el.style.display = "none";
    } else {
      el.style.display = "block";
    }
    _setLoading(show);
  };
  const setSurveyInfo = (data) => {
    formateData(data);
    form.setFieldsValue({ suveryInfo: data });
    dispatch(appReducersActions.setSurveyInfo(data));
    showStorage(data);
  };
  const handlePreviewMsg = ({ data: msgData }) => {
    //previewType == 1 不需要请求，数据由iframe通讯传递,  2 需要请求，数据由接口获得
    if (msgData.type == "iframe" && params.previewType !== "2") {
      setSurveyInfo(msgData.data);
    }
  };

  useEffect(() => {
    window.addEventListener("message", handlePreviewMsg, false);
    return () => {
      window.removeEventListener("message", handlePreviewMsg);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    actions
      .getLanguageInfo()
      .then((data) => {
        dispatch(appReducersActions.setMessage(data));
      })
      .then(() => {
        // 记录当前时间
        dispatch(appReducersActions.setFirstTime(new Date().getTime()));
        if (params.previewType) {
          dispatch(
            appReducersActions.setPreview({
              previewType: params.previewType,
              check: params.check,
            })
          );
          if (params.previewType === "2") return actions.getSurvey(true);
          else return;
        } else if (params.id || params.surveyCode || params.surveyId) {
          if (getFinger()) {
            return actions.getSurvey();
          } else {
            return Fingerprint2.getPromise({}).then((components) => {
              var values = components.map((o) => o.value);
              let userfinger = Fingerprint2.x64hash128(values.join(""), 31);
              setFinger(userfinger);
              return actions.getSurvey();
            });
          }
        } else {
          return Promise.reject({ code: 10006 });
        }
      })
      .then((data) => {
        if (data) setSurveyInfo(data);
        setTimeout(() => {
          setLoading(false);
        }, 0);
      })
      .catch((e) => {
        console.log("e", e);
        if (e instanceof Error) {
          dispatch(appReducersActions.setTipsPage({ status: "network" }));
        } else {
          dispatch(appReducersActions.setTipsPage({ status: e.code }));
        }
        setTimeout(() => {
          setLoading(false);
        }, 0);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { loading };
};

export const useStoreToForm = (form) => {
  const dispatch = useDispatch();
  const { firstTime } = useSelector((state) => state.app);
  const { handler: jumpHandler } = useJumpHandler(form);
  const { handler: relateHandler } = useRelateHandler(form);
  const handler = (type) => {
    dispatch(appReducersActions.setStorageModal(false));
    let suveryInfo = form.getFieldValue("suveryInfo");
    if (type == false) {
      removeAnswer(suveryInfo.id);
      return;
    }
    let { questionList: quesList } = suveryInfo;
    let postAnswer = [];
    let storeData = getAnswer(suveryInfo.id);
    let jumpType = "0";
    storeData.answerData.forEach((item) => {
      let position = item[0];
      let type = item[1].toString();
      let _data = item[2];
      let quesItem = quesList[position];
      let answerData;
      if (type != quesItem.type) {
        return;
      }
      switch (type) {
        case "1":
        case "2":
        case "8":
        case "9":
          answerData = _data.split(",").map((_item) => {
            let [answerIndex, answerText] = _item.split("=>");
            let ansItem = quesItem.answerList.find(
              (o) => o.position.toString() == answerIndex.toString()
            );
            if (!ansItem) return undefined;
            return {
              answerId: ansItem.id,
              position: answerIndex,
              answerText,
              checked: true,
              source: ansItem,
            };
          });
          break;
        case "3":
          answerData = _data;
          break;
        case "10":
          answerData = _data?.split(",").map((o) => ({
            status: "success",
            url: o,
            fileId: Math.floor(Math.random() * 100000),
          }));
          break;
        case "6":
        case "7":
          answerData = _data
            .split(",")
            .map((_item) => {
              let [rowPosition, colPosition] = _item.split("_");
              let rowItem = quesItem.matrixRowList.find(
                (o) => o.position.toString() == rowPosition.toString()
              );
              let colItem = quesItem.answerList.find(
                (o) => o.position.toString() == colPosition.toString()
              );
              if (!rowItem || !colItem) return undefined;
              return {
                matrixId: rowItem.id,
                rowPosition: rowItem.position,
                answerId: colItem.id,
                colPosition: colItem.position,
              };
            })
            .filter((o) => o);
          break;
        default:
          break;
      }
      postAnswer[position] = answerData;
      let { jumpType: _jumpType } = jumpHandler({
        quesList,
        quesItem,
        answerData,
        postAnswer,
      });
      if (jumpType == "0" && _jumpType) jumpType = _jumpType;
    });
    // 处理关联逻辑
    relateHandler({ quesList, postAnswer });
    form.setFieldsValue({
      postAnswer,
      suveryInfo: { ...suveryInfo, questionList: quesList },
    });
    // 设置是否下一页为跳转到卷尾
    dispatch(appReducersActions.setJumpType(jumpType));
    dispatch(appReducersActions.setCurrentPage(storeData.currentPage));
    //花费时长 = 上一次答题的时间 - 获取问卷详情的时间
    //花费时长叠加,存入store
    let costTime = storeData.answerTime - storeData.lastFirstTime;
    costTime = costTime > 0 ? costTime : 0;
    storeData.costTime = storeData.costTime
      ? storeData.costTime + costTime
      : costTime;
    storeData.lastFirstTime = firstTime;
    setAnswer(suveryInfo.id, storeData);
  };
  return { handler };
};

export const useFormateMsg = () => {
  const intl = useIntl();
  const handler = (id, values, msg) => {
    return intl.formatMessage({ id, defaultMessage: msg || id }, values);
  };
  return { formatMsg: handler };
};

export const useUtils = () => {
  // 判断该题型是否可填答案 排除4-分页符,5-段落说明等类型
  const isQuestion = (quesType) => {
    return ["4", "5"].indexOf(quesType.toString()) < 0;
  };
  // 判断两个字符串或数字是否相等
  const isSame = (a, b) => {
    return a?.toString() === b?.toString();
  };
  // 检查答案是否为空
  const checkEmpty = (value, quesType) => {
    let status;
    switch (quesType.toString()) {
      case "1":
      case "2":
      case "8":
      case "9":
        status = !value?.find((o) => o.checked);
        break;
      case "3":
        status = !value?.toString().trim();
        break;
      case "4":
      case "5":
        status = false;
        break;
      case "6":
      case "7":
        status = !value;
        break;
      case "10":
        status = !value || value.length === 0;
        break;
      default:
        status = true;
        break;
    }
    return status;
  };

  return { isQuestion, isSame, checkEmpty };
};

export const useIsMoblie = () => {
  const { isSame } = useUtils();
  const dispatch = useDispatch();
  const mobileMaxWidth = 760;
  const isMobile = useMemo(() => {
    let { isMobile } = getUrlParamsBySearch();
    let check = false;
    if (isMobile) {
      check = isSame(isMobile, "1");
    } else {
      /* eslint-disable */
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      if (!check) {
        let isMobileDevice = window.matchMedia(
          `only screen and (max-width: ${mobileMaxWidth}px)`
        ).matches;
        check = isMobileDevice;
      }
    }
    /* eslint-enable */
    dispatch(appReducersActions.setIsMobile(check));
    return check;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isMobile;
};
